export default (state=[], action) => {
    switch(action.type) {
        case "POLLS_FETCHED":
            return action.polls;
        case "FAILED_FETCH":
            return [0];
        default:
            return state;
    }
};